/**
 * 뉴스룸 페이지
 * 상단 탭(유튜브/블로그/인스타) 클릭 시 해당 섹션으로 스무스 스크롤하고,
 * 스크롤 위치에 맞춰 활성 탭을 갱신(스크롤스파이)한다.
 */
export function initNewsroom() {
  const tabNav = document.querySelector(".newsroom-tabs");
  if (!tabNav) return;

  const tabs = Array.from(tabNav.querySelectorAll(".newsroom-tabs__btn"));
  if (!tabs.length) return;

  const sections = tabs
    .map((tab) => document.getElementById(tab.dataset.target))
    .filter(Boolean);
  if (!sections.length) return;

  const header = document.getElementById("main-header");

  const setActive = (id) => {
    tabs.forEach((tab) => {
      tab.classList.toggle("is-active", tab.dataset.target === id);
    });
  };

  // 탭 클릭 → 해당 섹션으로 스무스 스크롤
  tabs.forEach((tab) => {
    tab.addEventListener("click", (event) => {
      event.preventDefault();
      const target = document.getElementById(tab.dataset.target);
      if (!target) return;

      const offset = header instanceof HTMLElement ? header.offsetHeight : 0;
      setActive(tab.dataset.target);

      if (window.__lenis) {
        window.__lenis.scrollTo(target, { offset: -offset });
        return;
      }

      const top =
        target.getBoundingClientRect().top +
        (window.scrollY || document.documentElement.scrollTop) -
        offset;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    });
  });

  // 스크롤스파이 (현재 화면 중앙에 들어온 섹션을 활성화)
  if (!("IntersectionObserver" in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActive(visible.target.id);
    },
    { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
  );

  sections.forEach((section) => observer.observe(section));
}
